/**
 * Maps ASP.NET validation keys and API messages to CompanyStaff form field names (PascalCase).
 */

const KEY_TO_FIELD = {
  username: "UserName",
  email: "Email",
  firstname: "FirstName",
  lastname: "LastName",
  passcode: "PassCode",
  password: "Password",
  confirmpassword: "ConfirmPassword",
  phoneno: "PhoneNo",
  country: "Country",
  city: "City",
  comrolepermission_id: "UserRoles",
  userroles: "UserRoles",
  rateperhour: "RatePerHour",
};

function normalizeValidationKey(key) {
  if (!key || typeof key !== "string") return null;
  const leaf = key.includes(".") ? key.split(".").pop() : key;
  const stripped = leaf.replace(/^\$\./, "").trim();
  const lower = stripped.toLowerCase();
  if (KEY_TO_FIELD[lower]) return KEY_TO_FIELD[lower];
  const pascal = stripped.charAt(0).toUpperCase() + stripped.slice(1);
  if (KEY_TO_FIELD[pascal.toLowerCase()]) return KEY_TO_FIELD[pascal.toLowerCase()];
  return KEY_TO_FIELD[lower] || null;
}

function mapKnownServerMessage(message) {
  if (!message || typeof message !== "string") return {};
  const m = message.toLowerCase();
  const out = {};
  if (m.includes("username") && (m.includes("already") || m.includes("given"))) {
    out.UserName = message;
  } else if (m.includes("email") && (m.includes("already") || m.includes("given"))) {
    out.Email = message;
  } else if (m.includes("pass code") || m.includes("passcode")) {
    out.PassCode = message;
  } else if (m.includes("password") || m.includes("pwd")) {
    out.Password = message;
  } else if (m.includes("role") || m.includes("permission")) {
    out.UserRoles = message;
  }
  return out;
}

/**
 * @param {object} data - axios response.data (ProblemDetails or BaseResponseModel)
 * @returns {{ fieldErrors: Record<string, string>, summary: string }}
 */
export function extractStaffFormErrors(data) {
  const fieldErrors = {};
  let summary = "";

  if (data?.errors && typeof data.errors === "object") {
    for (const [key, val] of Object.entries(data.errors)) {
      const field = normalizeValidationKey(key);
      const msgs = Array.isArray(val) ? val : [val];
      const text = msgs.map(String).filter(Boolean)[0];
      if (field && text) {
        fieldErrors[field] = text;
      }
    }
    summary =
      data.title ||
      data.detail ||
      Object.values(fieldErrors)[0] ||
      "Please correct the highlighted fields.";
  }

  if (data?.message && typeof data.message === "string") {
    const trimmed = data.message.trim();
    if (Object.keys(fieldErrors).length === 0) {
      Object.assign(fieldErrors, mapKnownServerMessage(trimmed));
    }
    summary = summary || trimmed;
  }

  return { fieldErrors, summary: summary || "Request could not be completed." };
}
